import { reducerTypes } from "./types";

export function toggleLoadingAction() {
  return {
    type: reducerTypes.TOGGLE_LOADING,
  };
}
